import React, { useState, useEffect, useRef } from 'react';
import Radium from 'radium';
import { Helmet } from "react-helmet";
import '../App.css';
import './Film.css';
import './Tech.css';
import FadeDiv from '../components/FadeDiv';
import useAutoScroll from  '../components/useAutoScroll.js'
import './Home.css';
import animation from '../resources/computer-science/animation.png';
import asset from '../resources/computer-science/asset.png';
import content from '../resources/computer-science/content.png';
import data from '../resources/computer-science/data_transfer.png';
import vfx from '../resources/computer-science/vfx.png';
import VisitWebsiteButton from '../components/VisitWebsiteButton';
import Modal from '../resources/Modal';
import p_aby from '../resources/computer-science/p_aby.png';
import p_spi from '../resources/computer-science/p_spi.png';
import p_twd from '../resources/computer-science/p_twd.jpg';
import p_zoe from '../resources/computer-science/p_zoe.jpg';
import p_str from '../resources/computer-science/p_str.jpg';
import p_pcj from '../resources/computer-science/p_pcj.jpg';
import p_btr from '../resources/computer-science/p_btr.png';
import p_fam from '../resources/computer-science/p_fam.png';
import p_see from '../resources/computer-science/p_see.png';
import p_wed from '../resources/computer-science/p_wed.png';
import p_tur from '../resources/computer-science/p_turnerhooch.jpeg';
import p_dun from '../resources/computer-science/p_dune.jpg';
import p_rop from '../resources/computer-science/p_rop.jpeg';
import p_kit from '../resources/computer-science/p_kitz.jpg';
import ue from '../resources/computer-science/unreal_engine.png';
import vp from '../resources/computer-science/virtual_production.png';
import vr from '../resources/computer-science/virtual_reality.png';
import cplusplus from '../resources/computer-science/c++.png';
import disguise from '../resources/computer-science/disguise.png';
import mosys from '../resources/computer-science/mosys.png';
import python_b from '../resources/computer-science/python_b.png';
import python_w from '../resources/computer-science/python_w.png';
import quest from '../resources/computer-science/quest.png';
import tensorflow from '../resources/computer-science/tensorflow.png';
import stype from '../resources/computer-science/stype.png';
import sql from '../resources/computer-science/sql.png';
import mariadb from '../resources/computer-science/mariadb.png';
import opencv from '../resources/computer-science/opencv.png';
import maya from '../resources/computer-science/maya.png';
import javascript from '../resources/computer-science/javascript.png';
import html from '../resources/computer-science/html.png';
import react from '../resources/computer-science/react.png';
import framer from '../resources/computer-science/framer.png';
import csharp from '../resources/computer-science/csharp.png';
import plus from '../resources/computer-science/plus.png';
import WebsiteWall from "../components/WebsiteWall";
import website_1 from "../resources/computer-science/website_1.jpg";
import website_2 from "../resources/computer-science/website_2.jpg";
import website_3 from "../resources/computer-science/website_3.jpg";
import website_4 from "../resources/computer-science/website_4.jpg";
import site_terra from "../resources/computer-science/site-terra.webp";
import site_resumesmithy from "../resources/computer-science/site-resumesmithy.webp";
import site_owez from "../resources/computer-science/site-owez.webp";
import site_tipt from "../resources/computer-science/site-tipt.webp";
import site_icon from "../resources/computer-science/site-openforanicon.webp";
import site_airtab from "../resources/computer-science/site-airtab.webp";
import site_maximus from "../resources/computer-science/site-maximus.webp";
import site_dylandalal from "../resources/computer-science/site-dylandalal.webp";
import site_feelgoodchiro from "../resources/computer-science/site-feelgoodchiro.webp";
import feelgoodchiro_full from "../resources/computer-science/web/feelgoodchiro-after-sm.webp";
import beeble1 from "../resources/computer-science/beeble1.jpg";
import {
  DataTransferComponent,
  AnimationComponent,
  VisualEffectsComponent,
  AssetOptimizationComponent,
  ContentReviewComponent
} from '../resources/computer-science/ModalContent';

const vana1 = `At MARZ VFX, I contributed to the development of Vanity AI, a production-ready solution designed to
               handle high volumes of advanced 2D visual effects. The tool specializes in cosmetic enhancements,
               delivering results up to 300x faster than traditional production methods.`;

const vana2 = `As a Machine Learning Pipeline Intern, I learned the fundamentals of building and distributing AI
               technology, and how to fit that new technology into an existing company pipeline.`;

const beeb1 = `I developed the official Unreal Engine plugin for Beeble, released by District Cinema in partnership
               with Beeble. It brings Beeble's relighting tools directly into the Unreal editor, letting artists
               work with them without leaving their scene.`;

const beeb2 = `The plugin is distributed on Epic Games' FAB marketplace as the official integration between
               District Cinema's Unreal pipeline and Beeble's platform.`;

const reims = `Before we started the Virtual Production volume, I lead the software development of a VR tour of France’s
               Notre Dame de Reims Cathedral. FSU partnered with the University of Alabama, who took a 3D scan of the
               cathedral using Matterport, which we had to clean and optimize before implementing gameplay features.`;
const reim2 = `The tour generated tens of thousands of dollars in funding for the College of Motion Picture Arts
               for preserving history through technology. It was my introduction to the Software Development Life Cycle
               and my first major project.`;

const virt1 = `In January 2021, the Florida State University College of Motion Picture Arts launched the Torchlight
               Center, the campus's hub for teaching film technology. I was their first hire and eventually ascended to
               the role of Senior Virtual Production Researcher with the responsibility of assembling the first Virtual
               Production volume ever purchased by a public university.`

const virt2 = `I researched technologies from many companies and experimented with a multitude before we settled on a
               Disguise-powered system with RedSpy Stype tracking. On top of wiring and routing data through the
               volume, I personally contributed to documentation that's been used for class material and trained faculty
               and staff on how to use the equipment.`

const virt3 = `It was my introduction to leading a team in a professional setting; to being a part of the planning,
               testing, and execution of a major project; and to the intricacies of working in a large organization.`;

const websi = `My passion for art and design makes creating dynamic websites a very interesting pastime. In addition to
               coding the websites, I usually take on the role of graphic designer, video editor, and brand manager.
               I've worked with a few companies on complete brand redesigns that you can explore below.`

const xbox1 = `A free browser tool for building Xbox controller layout diagrams. Type what each button does, label
               your controls and drag them around if you want, then export the finished diagram as SVG and PNG.`

const xbox2 = `Everything runs client-side. There's no persistence/database on this site, so I built a JSON
               checkpoint system for users to edit their diagrams later.`

const svm1 = `My Machine Learning course at school tasked us with creating a support vector machine from scratch that
              would draw the most precise line separating two overlapping datasets.`

const svm2 = `By far the most challenging project I worked on during college, I learned a great deal about supervised
              machine learning algorithms.`

const webapp1 = `The resulty of the entirety of my Introduction to C# course, the TaskManager Application provides a
                full User Interface written in Xamarin.Forms for local user interaction with a WebAPI.`

const webapp2 = `The WebAPI is written using the .NET framework and locally saves inputted tasks to a JSON file for
                 persistent usage of the API.`

const space = `\n`;

const piped = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam lobortis  elementum dapibus. Morbi
               accumsan iaculis metus. Nulla nec erat magna.`;

const auto1 = `Python pipeline that converts Reddit stories into fully-captioned YouTube Shorts: it scrapes posts with
               PRAW, trims the script with GPT-4o, generates voice-over in ElevenLabs, aligns word-timings via WhisperX,
               and stitches everything together with FFmpeg into a ready-to-upload 9:16 video.`;

const auto2 = `My goal was to do as little as possible, while uploading as much as possible. This pipeline achieved
               exactly that. The channel never got any traction, though.`

const site_cohort = process.env.PUBLIC_URL + "/cohort.jpg";

// shift = parallax travel in column-widths (sign sets direction; 3-card columns with one tall
// capture are short, so keep them under ~0.4 or their ends scroll into view). Tall captures scroll inside their frame
// from `from`% to `from + pan`% of their own height, so one capture can appear twice as different pages.
const website_wall = [
  { shift: -0.34, shots: [
    { kind: "wide", src: site_terra },
    { kind: "tall", src: website_1, from: 0, pan: 22 },
    { kind: "wide", src: site_owez },
  ]},
  { shift: 0.8, shots: [
    { kind: "tall", src: feelgoodchiro_full, from: 0, pan: 22 },
    { kind: "wide", src: site_icon },
    { kind: "tall", src: website_3, from: 26, pan: 22 },
  ]},
  { shift: -0.38, shots: [
    { kind: "wide", src: site_resumesmithy },
    { kind: "tall", src: website_2, from: 0, pan: 22 },
    { kind: "wide", src: site_maximus },
  ]},
  { shift: 0.6, shots: [
    { kind: "tall", src: website_4, from: 0, pan: 24 },
    { kind: "wide", src: site_airtab },
    { kind: "tall", src: website_1, from: 27, pan: 22 },
  ]},
  { shift: -0.3, shots: [
    { kind: "wide", src: site_feelgoodchiro },
    { kind: "tall", src: website_3, from: 0, pan: 22 },
    { kind: "wide", src: site_cohort },
  ]},
  { shift: 0.75, shots: [
    { kind: "tall", src: website_2, from: 27, pan: 22 },
    { kind: "wide", src: site_tipt },
    { kind: "tall", src: feelgoodchiro_full, from: 44, pan: 22 },
  ]},
  { shift: -0.36, shots: [
    { kind: "wide", src: site_dylandalal },
    { kind: "tall", src: website_4, from: 38, pan: 24 },
    { kind: "wide", src: site_terra },
  ]},
];

const asoj_intro = [
  {
    videoId: 'kfyY9aGAVLE',
  }
];

function Tech() {
  const [selectedContent, setSelectedContent] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [modalHeader, setModalHeader] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const carouselRef = useRef(null);
  useAutoScroll(carouselRef, 170, 2000);

  const openModal = (type) => {
    setIsModalOpen(true);
    switch (type) {
      case 'Data Transfer':
        setModalHeader('Data Transfer');
        setModalContent(<DataTransferComponent />); // Importing component from ModalContent.js
        break;
      case 'Animation':
        setModalHeader('Animation');
        setModalContent(<AnimationComponent />); // Importing component from ModalContent.js
        break;
      case 'Visual Effects':
        setModalHeader('Visual Effects');
        setModalContent(<VisualEffectsComponent />); // Importing component from ModalContent.js
        break;
      case 'Game Development':
        setModalHeader('Game Development');
        setModalContent(<AssetOptimizationComponent />); // Importing component from ModalContent.js
        break;
      case 'Content Review':
        setModalHeader('Content Review');
        setModalContent(<ContentReviewComponent />); // Importing component from ModalContent.js
        break;
      default:
        setModalContent(null);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null); // Clear modal content on close
  };

  // Build a listener to close pipeline development modal with Escape key
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    }; if (selectedContent) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedContent]);

    return (
    <>
    <Helmet>
        <title>Dylan Dalal | Technical Portfolio</title>
        <meta name="description" content="Explore Dylan Dalal's software engineering and tech projects in AI, pipeline development, and virtual production." />

        {/* Schema Markup */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Person",
            "name": "Dylan Dalal",
            "url": "https://dylandalal.com",
            "image": "https://dylandalal.com/profile.jpg",
            "jobTitle": "Software Engineer & Pipeline Developer",
            "sameAs": [
              "https://linkedin.com/in/dylandalal",
              "https://github.com/dylandalal",
              "https://twitter.com/dylandalal"
            ]
          }
          `}
        </script>
      </Helmet>

      <div className="first_tech" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ alignItems: 'left' }}>
          <div className="tech-logos" style={{ display: 'flex', alignItems: 'center', margin: '0 3vw 0 3vw', paddingBottom: "0" }}>
            <div>
              <img className="tech-logo" src={python_w} alt="Dylan Dalal Python" style={{ margin: "0 5px 0 5px" }}/>
            </div>
          </div>
          <div className="header_pipeline" style={{ color: 'white', margin: '0 3vw 0 3vw', alignItems: 'left' }}>
            Pipeline Development
          </div>
          <div className="body_no_padding" style={{ color: 'white', margin: '0 3vw 0 3vw' }}>
            Many of my projects have focused on optimizing workflows, and I have been specifically employed as a
            Pipeline Developer at three companies. Choose a specialization for more details.
          </div>
        </div>
        {/* Carousel */}
        <div className="carousel-container" style={{ paddingBottom: "5vh", overflowX: "visible", margin: "0 0 0 0"}}>
           <ul className="carousel" ref={carouselRef} style={{ overflowX: "auto", overflowY: "hidden", padding: "1%" }}>
            <li className="carousel-item" onClick={() => openModal('Data Transfer')}>
              <img className="carousel-plus" src={plus} alt="Dylan Dalal" />
              <img src={data} alt="Dylan Dalal Data Transfer" />
              <div className="carousel-text">data transfer</div>
            </li>
            <li className="carousel-item" onClick={() => openModal('Animation')}>
              <img className="carousel-plus" src={plus} alt="Dylan Dalal" />
              <img src={animation} alt="Dylan Dalal Animation" />
              <div className="carousel-text">animation</div>
            </li>
            <li className="carousel-item" onClick={() => openModal('Visual Effects')}>
              <img className="carousel-plus" src={plus} alt="Dylan Dalal" />
              <img src={vfx} alt="Dylan Dalal Visual Effects" />
              <div className="carousel-text">visual effects</div>
            </li>
            <li className="carousel-item" onClick={() => openModal('Game Development')}>
              <img className="carousel-plus" src={plus} alt="Dylan Dalal" />
              <img src={asset} alt="Dylan Dalal Game Development" />
              <div className="carousel-text">game development</div>
            </li>
            <li className="carousel-item" onClick={() => openModal('Content Review')}>
              <img className="carousel-plus" src={plus} alt="Dylan Dalal" />
              <img src={content} alt="Dylan Dalal Content Review" />
              <div className="carousel-text">content review</div>
            </li>
          </ul>
        </div>
      </div>
      <div className="second_tech" style={{ position: 'relative', zIndex: 1 }}>
        <div className="tech-logos" style={{ display: 'flex', alignItems: 'center', paddingBottom: "0" }}>
          <div>
            <img className="tech-logo" src={python_b} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }}/>
            <img className="tech-logo" src={tensorflow} alt="Dylan Dalal" style={{ margin: "0 5px 7px 5px" }} />
            <img className="tech-logo" src={sql} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }} />
            <img className="tech-logo" src={mariadb} alt="Dylan Dalal" style={{ margin: "0 5px 2px 5px" }} />
            <img className="tech-logo" src={opencv} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }} />
          </div>
        </div>
        <div className="header_pipeline" style={{ color: 'black', alignItems: 'left', paddingBottom: '10px' }}>
          Saving $8 Million with Vanity A.I.
        </div>
        <div style={{  alignItems: 'center'  }}>
            <div className="column-container2" style={{gap: "2vw"}}>
              <div style={{maxWidth: "75vw"}}>
                <div className="body_no_padding" style={{ color: 'black' }}>{vana1}</div>
                <div className="body_no_padding" style={{ color: 'black' }}>{vana2}</div>
                <div style={{ textAlign: 'center' }}>
                  <VisitWebsiteButton url="https://monstersaliensrobotszombies.com/vanityai" />
                </div>
              </div>
              <div style={{ margin: '0px', paddingBottom: '0px'}}>
                <div
                  id="autoscroll"
                  className="carousel-container"
                  style={{}}
                  ref={carouselRef}
                >
                  <ul className="carousel" style={{paddingBottom: '10px', margin: '0px', maxWidth: "80vw"}}>
                    <li className="carousel-item2">
                      <img src={p_tur} alt="Dylan Dalal worked on Turner & Hooch" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_kit} alt="Dylan Dalal worked on Kitz" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_see} alt="Dylan Dalal worked on See" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_aby} alt="Dylan Dalal worked on Anyone But You" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_dun} alt="Dylan Dalal worked on Dune: Prophecy" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_str} alt="Dylan Dalal worked on Stranger Things Season 4" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_spi} alt="Dylan Dalal worked on Spider-Man: No Way Home" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_pcj} alt="Dylan Dalal worked on Percy Jackson and the Olympians" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_dun} alt="Dylan Dalal worked on Dune: Prophecy" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_twd} alt="Dylan Dalal worked on The Walking Dead" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_rop} alt="Dylan Dalal worked on Rings of Power" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_fam} alt="Dylan Dalal worked on For All Mankind" />
                    </li>
                    <li className="carousel-item2">
                      <img src={p_zoe} alt="Dylan Dalal worked on Zoe's Extraordinary Playlist" />
                    </li>
                  </ul>
                </div>
                <div className="body_no_padding" style={{ color: '#9e9e9e', textAlign: 'center' }}>
                  used in 45+ major productions to date
                </div>
              </div>
          </div>
        </div>
      </div>
      <div className="second_tech" style={{ position: 'relative', zIndex: 1, paddingTop: "6vh", alignItems: 'center', paddingBottom: "6vh" }}>
        <div className="tech-logos" style={{ display: 'flex', alignItems: 'center', paddingBottom: "0" }}>
          <div>
            <img className="tech-logo" src={ue} alt="Dylan Dalal Unreal Engine" style={{ margin: "0 5px 0 5px" }}/>
            <img className="tech-logo" src={cplusplus} alt="Dylan Dalal C++" style={{ margin: "0 5px 0 5px" }} />
          </div>
        </div>
        <div className="header_pipeline" style={{ color: 'black', alignItems: 'center', paddingBottom: '10px' }}>
          The Official Beeble Plugin for Unreal Engine
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: 'center', justifyContent: 'center' }}>
          <img
            src={beeble1}
            alt="Dylan Dalal Beeble Unreal Engine Plugin"
            style={{
              maxWidth: "55vw",
              width: "100%",
              height: "auto",
              borderRadius: "16px",
              border: "1px solid rgba(11, 19, 58, 0.12)",
              boxShadow:
                "0 8px 32px rgba(11, 19, 58, 0.12), 0 2px 8px rgba(11, 19, 58, 0.07)",
              marginBottom: "3vh"
            }}
          />
          <div style={{ maxWidth: "55vw" }}>
            <div className="body_no_padding" style={{ color: 'black' }}>{beeb1}</div>
            <div className="body_no_padding" style={{ color: 'black' }}>{beeb2}</div>
            <div style={{ textAlign: 'center' }}>
              <VisitWebsiteButton url="https://www.fab.com/listings/74c23d42-8fd2-4c1f-a33d-e588f9ece6c0" text="View on FAB" newTab={true} />
            </div>
          </div>
        </div>
      </div>
      <div className="third_tech" style={{ position: 'relative', display: 'flex', alignItems: 'center', paddingTop: '6vh' }}>
        <div className="column-container" style={{ gap: '5vw', paddingBottom: '0', alignItems: 'center' }}>
            <div class="image-container">
              <img src={vp} alt="Dylan Dalal Virtual Production"/>
                <div className="vp-container">
                  <div className="vp-content">
                    <div className="vp-text">VIRTUAL</div>
                    <div className="vp-text small">PRODUCTION</div>
                  </div>
                </div>
            </div>
            <div style={{ maxWidth: "75vw"}}>
                <div className="tech-logos">
                  <div>
                    <img className="tech-logo" src={python_b} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }}/>
                    <img className="tech-logo" src={ue} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }} />
                    <img className="tech-logo" src={disguise} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }} />
                    <img className="tech-logo" src={mosys} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }} />
                    <img className="tech-logo" src={stype} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }} />
                  </div>
                </div>
                <div className="header2_pipeline" style={{ color: 'black', paddingBottom: '10px'}}>
                    THE FIRST ACADEMIC VP STAGE
                </div>
                <div style={{maxWidth: "75vw", alignItems: "center"}}>
                    <div className="body_no_padding" style={{ color: 'black' }}>{virt1}</div>
                    <div className="body_no_padding" style={{ color: 'black' }}>{virt2}</div>
                    <div className="body_no_padding" style={{ color: 'black' }}>{virt3}</div>
                </div>
            </div>
        </div>
      </div>
      <div className="third_tech" style={{ position: 'relative', display: "flex", alignItems: "center", paddingTop: "0" }}>
        <div className="column-container2" style={{ gap: '5vw' }}>
                <div style={{maxWidth: "80vw"}}>
                <div className="tech-logos" style={{ display: 'flex', alignItems: 'center', paddingBottom: "0"}}>
                  <div>
                    <img className="tech-logo" src={cplusplus} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }}/>
                    <img className="tech-logo" src={ue} alt="Dylan Dalal" style={{ margin: "0 5px 2px 5px" }} />
                  </div>
                </div>
                <div className="header2_pipeline" style={{ color: 'black', alignItems: 'left'}}>
                    PRESERVING HISTORY WITH VR
                </div>
                <div>
                    <div className="body_no_padding" style={{ color: 'black' }}>{reims}</div>
                    <div className="body_no_padding" style={{ color: 'black' }}>{reim2}</div>
                    <div style={{ textAlign: 'center' }}>
                        <VisitWebsiteButton url="https://www.jenniferfeltman.com/vrcathedral" />
                    </div>
                </div>
            </div>
            <div class="image-container">
              <img src={vr} alt="Dylan Dalal Virtual Reality"/>
                <div className="vr-container">
                  <div className="vr-content">
                    <div className="vr-text">VIRTUAL</div>
                    <div className="vr-text small">REALITY</div>
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div className="second_tech" style={{ position: 'relative', zIndex: 1, paddingTop: "6vh", alignItems: 'center', paddingBottom: "6vh"}}>
        <div className="tech-logos" style={{ display: 'flex', alignItems: 'center', paddingBottom: "0" }}>
          <div>
            <img className="tech-logo" src={react} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }}/>
            <img className="tech-logo" src={javascript} alt="Dylan Dalal" style={{ margin: "0 5px 0px 5px" }} />
            <img className="tech-logo" src={html} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }} />
            <img className="tech-logo" src={framer} alt="Dylan Dalal" style={{ margin: "0 5px 2px 5px" }} />
          </div>
        </div>
        <div className="header_pipeline" style={{ color: 'black', alignItems: 'center', paddingBottom: '10px' }}>
          Elevating Brands with Elegant Websites
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: 'center', justifyContent: 'center' }}>
          <WebsiteWall columns={website_wall} />
          <div style={{maxWidth: "55vw"}}>
            <div className="body_no_padding" style={{ color: 'black' }}>{websi}</div>
            <div style={{ textAlign: 'center'}}>
              <VisitWebsiteButton url="/web" text="View portfolio" newTab={true} />
            </div>
          </div>
        </div>
      </div>
      <div className="fourth_tech" style={{ position: 'relative', zIndex: 1 }}>
        <div class="grid">
          <div class="grid-item">
            <div className="tech-logos" style={{ display: 'flex', padding: "20px 0 0 0"}}>
              <div>
                <img className="tech-logo" src={react} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }}/>
                <img className="tech-logo" src={javascript} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }} />
              </div>
            </div>
            <h3>Xbox Controller Diagram Maker</h3>
            <p>{xbox1}</p>
            <p>{xbox2}</p>
            <div style={{ margin: "1vh 0 2vh 0" }}>
              <VisitWebsiteButton url="/xbox" text="Try the tool" newTab={true} />
            </div>
          </div>
          <div class="grid-item dark">
                      <div className="tech-logos" style={{ display: 'flex', alignItems: 'center', padding: "20px 0px 0px 0px"}}>
              <div>
                <img className="tech-logo" src={python_w} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }}/>
              </div>
            </div>
            <h3>Short-Form Video Creation Pipeline</h3>
            <p>{auto1}</p>
            <p>{auto2}</p>
            <VisitWebsiteButton url="https://github.com/DylanDalal/AutoTube" text="View repository" />
          </div>
          <div class="grid-item">
            <div className="tech-logos" style={{ display: 'flex', alignItems: 'center', padding: "20px 0px 0px 0px"}}>
              <div>
                <img className="tech-logo" src={csharp} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }}/>
                <img className="tech-logo" src={sql} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }} />
              </div>
            </div>
            <h3>C# Webapp Implementation</h3>
            <p>{webapp1}</p>
            <p>{webapp2}</p>
            <div style={{ margin: "1vh 0 2vh 0" }}>
              <VisitWebsiteButton url= "https://github.com/DylanDalal/my-work/tree/main/c-sharp/TaskManagerUI-WebAPI"
                                  text="View repository"/>
            </div>
          </div>
          <div class="grid-item dark">
            <div className="tech-logos" style={{ display: 'flex', alignItems: 'center', padding: "20px 0px 0px 0px"}}>
              <div>
                <img className="tech-logo" src={python_w} alt="Dylan Dalal" style={{ margin: "0 5px 0 5px" }}/>
              </div>
            </div>
            <h3>SVM Classifier Without sklearn</h3>
            <p>{svm1}</p>
            <p>{svm2}</p>
            <div style={{ margin: "1vh 0 2vh 0" }}>
              <VisitWebsiteButton url= "https://github.com/DylanDalal/my-work/tree/main/Python/Support-Vector-Machine"
                                  text="View repository"/>
            </div>
          </div>
          <div class="grid-item">
            <h3>Classwork</h3>
            <div style={{ margin: "1vh 0 2vh 0" }}>
              <VisitWebsiteButton url="https://github.com/DylanDalal/my-work" text="View repository" />
            </div>
          </div>
          <div class="grid-item dark">
            <h3>This Website</h3>
            <div style={{ margin: "1vh 0 2vh 0" }}>
              <VisitWebsiteButton url="https://github.com/DylanDalal/website" text="View repository" />
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        headerText={modalHeader}
        bodyContent={modalContent}
        onClose={closeModal}
      />
    </>
  );
}


export default Radium(Tech);
